/**
 * Truncates text to a specified length and checks if it needs truncation
 * @param {string} text - The text to potentially truncate
 * @param {number} maxLength - Maximum character length before truncation
 * @returns {object} - Object with truncated text, needsTruncation boolean, and original text
 */
export const truncateText = (text, maxLength = 150) => {
  if (!text || typeof text !== "string") {
    return {
      truncated: "",
      needsTruncation: false,
      original: text || "",
    };
  }

  const needsTruncation = text.length > maxLength;
  const truncated = needsTruncation
    ? text.substring(0, maxLength) + "..."
    : text;

  return {
    truncated,
    needsTruncation,
    original: text,
  };
};

/**
 * Checks if text is long enough to benefit from a "view more" modal
 * @param {string} text - The text to check
 * @param {number} threshold - Character threshold
 * @returns {boolean} - True if text is long enough
 */
export const isTextLong = (text, threshold = 100) => {
  return text && text.length > threshold;
};
